export default __webpack_public_path__ + "static/media/logo.fb57cc6c.svg";